import api from "../services/api";

export async function acesso(ipv4,location,script) {
    if(!localStorage.getItem("Session")){
        localStorage.setItem("Session",Date.now());
    } else {
        const session = parseInt(localStorage.getItem("Session"))+(24*60*60*1000);
        if (Date.now()>session){
            localStorage.setItem("Session",Date.now());
        }
    }
    const data = {
        'IP': ipv4,
        'script': script,
        'script_full':location,
        'sessionid': localStorage.getItem("Session"),
    };
    await api.post(
        "/api/SAP",
        data
    );
}